<template>
    <div class="card" style="border-width: 0px" v-if="hasRole('Administrator')||hasRole('Berater')||hasRole('Erweiterter Einkäufer')">
        <div class="card-header px-0" style="background-color: #f4f5fa">
            {{ $t("risk.header_self") }}
        </div>
        <div class="card-body px-0" style="background-color: #f4f5fa">
            <b-tabs>
                <b-tab title="Allgemeine Übersicht">
                    <EGBRiskTab />
                </b-tab>
                <b-tab title="Auswertung abstrakte Risikoanalyse">
                    <EGBScoreTab />
                </b-tab>
                <b-tab title="Auswertung konkrete Risikoanalyse">
                    <EGBAnalysisTab />
                </b-tab>
                <b-tab title="Heatmaps konkrete Risikoanalyse">
                    <EGBHeatmaps />
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import { dateHelper } from '../../../mixins/dateHelper';
import EGBRiskTab from './modules/EGBRiskTab';
import EGBScoreTab from './modules/EGBScoreTab';
import EGBAnalysisTab from './modules/EGBAnalysisTab';
import EGBHeatmaps from './modules/EGBHeatmaps';

export default {
    name: 'supplychainact',
    components: { 
        EGBRiskTab,
        EGBScoreTab,
        EGBAnalysisTab,
        EGBHeatmaps,
    },
    mixins: [dateHelper],
    data() {
        return {
            stickyHeader: true,
        }
    },
    created() {
    },
    methods: {

    },
    computed: {
        ...mapGetters({
            hasRole: 'auth/hasRole',
        }),
    }
};
</script>
